import { createRef, useCallback, useEffect, useState } from 'react';

/**
 * Hook to scroll to the active tab when it is not in the viewport.
 * @param tabs - The tabs to scroll to.
 * @param activeTabIndex - The index of the active tab.
 * @returns The refs of all the tabs.
 */
export var useScrollToActiveTab = _ref => {
  var {
    tabsListRef,
    tabs,
    activeTabIndex
  } = _ref;
  var [tabsRefs, setTabsRefs] = useState([]);
  var [activeTabCurrentRef, setActiveTabCurrentRef] = useState();
  var scrollToActiveTab = useCallback(() => {
    if (activeTabCurrentRef) {
      var _tabsListRef$current;

      (_tabsListRef$current = tabsListRef.current) === null || _tabsListRef$current === void 0 ? void 0 : _tabsListRef$current.scrollTo({
        left: activeTabCurrentRef.offsetLeft,
        behavior: 'smooth'
      });
    }
  }, [activeTabCurrentRef, tabsListRef]);
  useEffect(() => {
    if (tabsRefs.length === 0) {
      setTabsRefs(Array(tabs.length).fill('').map(() => /*#__PURE__*/createRef()));
    }
  }, [tabs, scrollToActiveTab, tabsRefs.length]);
  useEffect(() => {
    var _tabsRefs$activeTabIn;

    if (!tabsRefs.length) return;
    setActiveTabCurrentRef((_tabsRefs$activeTabIn = tabsRefs[activeTabIndex]) === null || _tabsRefs$activeTabIn === void 0 ? void 0 : _tabsRefs$activeTabIn.current);
    scrollToActiveTab();
  }, [scrollToActiveTab, tabsRefs.length, activeTabIndex, tabsRefs]);
  return {
    tabsRefs
  };
};
//# sourceMappingURL=useScrollToActiveTab.js.map